import React, { Fragment } from 'react';
import { withAnalytics } from '../../common/analytics';
import { onAdvancedSearchSelected } from '../../common/analytics/events';
import { NoResults } from '../../common/no-results';
import { useQuery } from '../query-context';
import { useAutocorrectionEnabled } from '../autocorrection/autocorrection-helper-functions';
import { AutocorrectAsyncWrapper } from '../autocorrection';
import { NoResultsAutocorrectWrapper } from '../autocorrection/autocorrection.styled';
var NoResultsWithHooks = function NoResultsWithHooks(_ref) {
  var _ref$urlGeneratorForN = _ref.urlGeneratorForNoResultsScreen,
    urlGeneratorForNoResultsScreen = _ref$urlGeneratorForN === void 0 ? function () {
      return '';
    } : _ref$urlGeneratorForN,
    advancedSearchSelected = _ref.advancedSearchSelected;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useAutocorrectionEna = useAutocorrectionEnabled(),
    autocorrectionEnabled = _useAutocorrectionEna.autocorrectionEnabled;
  var advancedSearchUrl = urlGeneratorForNoResultsScreen(query); // TODO: needs filters here

  return /*#__PURE__*/React.createElement(Fragment, null, autocorrectionEnabled && /*#__PURE__*/React.createElement(AutocorrectAsyncWrapper, {
    container: NoResultsAutocorrectWrapper
  }), /*#__PURE__*/React.createElement(NoResults, {
    advancedSearchUrl: advancedSearchUrl,
    advancedSearchSelected: advancedSearchSelected
  }));
};
export default withAnalytics({
  advancedSearchSelected: onAdvancedSearchSelected
})(NoResultsWithHooks);